import { Component, OnInit, HostListener } from '@angular/core';
import Swiper from 'swiper'

@Component({
  selector: 'app-swiper',
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.scss']
})
export class SwiperComponent {

  swiper = {}

  constructor() { }

  ngAfterViewInit() {
    this.swiper = new Swiper('.swiper-container', {
      // Optional parameters
      slidesPerView: 7,
      slidesPerGroup: 7,
      slidesPerColumnFill: 'row',
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is <= 1199px
        1199: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          noSwiping: false
        },

        991: {
          slidesPerView: 5,
          slidesPerGroup: 5
        },

        767: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },

        575: {
          slidesPerView: 2,
          slidesPerGroup: 2
        }
      },
    })
  }

}
